import { MeResponseSchema } from '@visep/shared-types/users';
import type { MeResponse } from '@visep/shared-types/users';
import type { Helpers } from './internal.js';

export function createUsersResource({ request }: Helpers) {
  return {
    async getMe(): Promise<MeResponse> {
      const data = await request('GET', '/api/users/me');
      return MeResponseSchema.parse(data);
    },
  };
}
